var base = {};

export { base as __exports };
